import React from 'react';
import ProducerInterface from 'modules/producers/interfaces/producer.interface';

import './producer-page-logo.scss';
import { MOBILE_PRODUCER_LOGO_HEIGHT, MOBILE_PRODUCER_LOGO_WIDTH, PRODUCER_LOGO_HEIGHT, PRODUCER_LOGO_WIDTH } from 'modules/producers/helpers/producers.const';
import { makeSrcSet } from 'modules/shared/helpers/image-sources';

const ProducerPageLogo: React.FC<{
    producer: ProducerInterface;
    isMobile: boolean;
}> = ({
    producer,
    isMobile
}) => {
    const textClassName = isMobile ? 'producer-page__text--mobile' : 'producer-page__text';
    const logoSources = isMobile ? producer.mainLogoSources?.mobile : producer.mainLogoSources?.desktop;
    const logoWidth = isMobile ? MOBILE_PRODUCER_LOGO_WIDTH : PRODUCER_LOGO_WIDTH;
    const logoHeight = isMobile ? MOBILE_PRODUCER_LOGO_HEIGHT : PRODUCER_LOGO_HEIGHT;

    return (
        <div className="producer-page__title">
            <div className={textClassName}>
                Strefa
            </div>
            {logoSources && (
                <img className="producer-page__logo"
                    src={logoSources.regular}
                    srcSet={makeSrcSet(logoSources.regular, logoSources.retina)}
                    alt={producer.name}
                    aria-label={producer.name}
                    width={logoWidth}
                    height={logoHeight}
                />
            )}
        </div>
    );
};

export default ProducerPageLogo;
